import React from 'react';
import './Title.css';

export const Title = ({ children }) => <h1 className="title">{children}</h1>;
